import React from 'react'
import PropTypes from 'prop-types'
import { Text, Spacer } from 'components/atoms'
import { PersonInfo } from 'components/molecules'
import { PersonUpdateForm, Error } from 'components/organisms'
import {
  getPeopleById, putPeopleById, PEOPLE_KEY, ALL_SUBWEB_PEOPLE
} from 'services/requests'
import { useQuery, useMutation, queryCache } from 'react-query'
import { usePersonImage } from 'hooks'
import { toast } from 'react-toastify'
import { Toast } from 'containers'

const PeopleDetail = ({ subweb, peopleId }) => {
  const {
    isLoading,
    isError,
    data
  } = useQuery([PEOPLE_KEY, { subweb, id: peopleId }], getPeopleById)
  const [updatePerson, {
    isLoading: isLoadingUpdatePerson
  }] = useMutation(putPeopleById, {
    onSuccess: () => {
      queryCache.invalidateQueries(PEOPLE_KEY)
      queryCache.invalidateQueries(ALL_SUBWEB_PEOPLE)
      toast.success(
        <Toast
          type="success"
          title="Informações atualizadas"
          description="Os dados do utilizador foram gravados com sucesso."
        />
      );
    },
    onError: (err) => {
      toast.error(
        <Toast
          type="error"
          title="Erro a atualizar informações do utilizador"
          description={err.message}
        />
      );
    }
  })

  const handleUpdatePerson = (values) => {
    updatePerson(values)
  }

  const person = React.useMemo(() => {
    if (data && data.data) return data.data
    return null
  }, [data])

  const {
    image,
    isLoading: isLoadingImage
  } = usePersonImage(person && person.photoId ? person.photoId : null)

  const initialValues = React.useMemo(() => {
    if (person) {
      const {
        visible,
        cabinet,
        email,
        externalPhone,
        internalPhone,
        jobAttributesEn,
        jobAttributesPt
      } = person
      return {
        visible,
        cabinet,
        email: email && email.length > 0 ? email[0] : '',
        externalPhone,
        internalPhone,
        jobPt: jobAttributesPt,
        jobEn: jobAttributesEn,
      }
    }
    return {}
  }, [person])

  if (isLoading || isLoadingImage) {
    return (
      <PersonInfo
        isLoading
      />
    )
  }

  if (isError) {
    return (
      <Error message="Erro a carregar pessoa" />
    )
  }

  return (
    <>
      <PersonInfo
        image={image}
        name={person.name}
        email={person.email && person.email.length > 0 ? person.email[0] : null}
      />
      {person.category && (
        <Spacer top="l">
          <Text modifiers={['base', 'content']}>Categoria</Text>
          <Text modifiers={['content']}>{person.category}</Text>
        </Spacer>
      )}
      <Spacer top="l" />
      <PersonUpdateForm
        initialValues={initialValues}
        subweb={subweb}
        peopleId={peopleId}
        isLoading={isLoadingUpdatePerson}
        onSubmit={handleUpdatePerson}
      />
    </>
  )
}

PeopleDetail.propTypes = {
  subweb: PropTypes.string.isRequired,
  peopleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default PeopleDetail
